<template>
  <div class="wrapper">
  <parallax class="section" ></parallax>
    <div class="main main-raised">
      <div class="text-center">
        <div v-if="loading">Now Loading...</div>
        <div v-else>
          <div v-if="status_code!=200">
            <div class="container" style="justify-content: space-around; padding: 50px 0px 30% 0px;">
              <h3>エラー：{{error_message}}</h3>
            </div>
          </div>
          <div v-else>
            <br>
            <div class="section section-contacts">
              <div class="container outer">
                <div v-if="shipmentData(2)==true">
                  <div class="flex-container">
                    <div class="inner">
                      <md-card style="box-shadow:none;">
                        <img
                          class ="img-work img-raised"
                          style="margin-top : 0px; object-fit: cover;"
                          :src=checkImage(shipmentData(0))
                          alt="Shipment Image"
                        >
                        <!-- :src=shipmentData(0) src="https://trace.smartag.jp/img/work_histories/0011_2_2021-07-02%2011:54:00.jpg"-->
                        <div class="md-layout">
                          <div class="md-layout-item md-layout md-alignment-center-space-around">
                            <div class="md-layout-item md-size-45" style="padding-left: 10%; padding-right: 0px;">
                              <h5 class="h5-size" style="text-align: left;">
                                <div class="heading-common heading-color-work"> 
                                  出荷日
                                </div>
                              </h5>
                            </div>
                            <div class="md-layout-item md-size-55" style="padding-left: 5%;">
                              <h5 class="h5-size" style="text-align: left;">
                                {{shipmentData(1)}}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </md-card>
                    </div>
                    <div class="inner" >
                      <md-card style="box-shadow:none;">
                        <img
                          :src=checkImage(producer.image)
                          alt="Producer Image"
                          class="img-raised rounded-circle img-fluid img-producer"
                          style="margin-top : 0px; object-fit: cover;"
                        >
                        <!-- :src=producer.image src="https://trace.smartag.jp/img/producers/producerSample.jpg" -->
                        <div class="md-layout">
                          <div class="md-layout-item md-layout md-alignment-center-space-around md-size-100">
                            <div class="md-layout-item md-size-45" style="padding-left: 10%; padding-right: 0px;">
                              <h5 class="h5-size" style="text-align: left;">
                                <div class="heading-common heading-color-producer"> 
                                  生産者
                                </div>
                              </h5>
                            </div>
                            <div class="md-layout-item md-size-55" style="padding-left: 5%;">
                              <h5 class="h5-size" style="text-align: left;">
                                {{ producer.producer_name }} （{{ producer.organization_name }}）
                              </h5>
                            </div>
                            <br>
                          </div>
                          <div class="md-layout-item md-layout md-alignment-center-space-around md-size-100">
                            <div class="md-layout-item md-size-45" style="padding-left: 10%; padding-right: 0px;">
                              <h5 class="h5-size" style="text-align: left; margin-top:0px;">
                                <div class="heading-common heading-color-producer"> 
                                  生産地
                                </div>
                              </h5>
                            </div>
                            <div class="md-layout-item md-size-55" style="padding-left: 5%;">
                              <h5 class="h5-size" style="text-align: left; margin-top:0px;">
                                {{ producer.address }}（{{ producer.field_name }}）
                              </h5>
                            </div>
                          </div>
                        </div>
                      </md-card>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="flex-container" style="justify-content: space-around !important;">
                    <div class="inner">
                      <md-card style="box-shadow:none;">
                        <img
                          :src=checkImage(producer.image)
                          alt="Producer Image"
                          class="img-raised rounded-circle img-fluid img-producer"
                          style="margin-top : 0px; object-fit: cover;"
                        >
                        <!-- :src=producer.image src="https://trace.smartag.jp/img/producers/producerSample.jpg" -->
                        <div class="md-layout md-alignment-center-space-around">
                          <div class="md-layout-item md-layout md-alignment-center-space-around md-size-100">
                            <div class="md-layout-item md-size-45" style="padding-left: 10%; padding-right: 0px;">
                              <h5 class="h5-size" style="text-align: left;">
                                <div class="heading-common heading-color-producer"> 
                                  生産者
                                </div>
                              </h5>
                            </div>
                            <div class="md-layout-item md-size-55" style="padding-left: 5%;">
                              <h5 class="h5-size" style="text-align: left;">
                                {{ producer.producer_name }} （{{ producer.organization_name }}）
                              </h5>
                            </div>
                            <br>
                          </div>
                          <div class="md-layout-item md-layout md-alignment-center-space-around md-size-100">
                            <div class="md-layout-item md-size-45" style="padding-left: 10%; padding-right: 0px;">
                              <h5 class="h5-size" style="text-align: left; margin-top:0px;">
                                <div class="heading-common heading-color-producer"> 
                                  生産地
                                </div>
                              </h5>
                            </div>
                            <div class="md-layout-item md-size-55" style="padding-left: 5%;">
                              <h5 class="h5-size" style="text-align: left; margin-top:0px;">
                                {{ producer.address }}（{{ producer.field_name }}）
                              </h5>
                            </div>
                          </div>
                        </div>
                      </md-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="feedback" class="section section-contacts">
              <div class="container">
                <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
                  <h2 class="text-center title h2-size">
                    <span class="newline-block">感想を</span><span class="newline-block">お寄せください</span>
                  </h2>
                  <h5 class="text-center h5-size">
                    <span class="newline-block">お召し上がりになった</span>
                    <span class="newline-block">感想やお気づきの点など、</span>
                    <span class="newline-block">生産者へのメッセージを</span><span class="newline-block">お待ちしております。</span>
                  </h5>
                  <form style="margin-top: 30px;" @submit.prevent>
                    <md-field class="has-green" md-clearable>
                      <label>Your Country</label>
                      <md-input v-model="country" type="text" required></md-input>
                    </md-field>
                    <md-field maxlength="5" md-clearable>
                      <label>Your Message</label>
                      <md-textarea v-model="message" required></md-textarea>
                    </md-field>
                    <div id="app">
                      <md-button class="md-button md-success md-theme-default mgt-1em" type=submit @click="confirmMessage()">Send Message</md-button>
                      <modal class="modal-mask" name="modal-confirm" draggable="true" :adaptive="true" :resizable="false"
                        :maxWidth="400" width="98%" height="150" styles="padding=15px;">
                        <h4 class="modal mgt-1em">本当に送信してよろしいですか？</h4>
                        <div class="button-mg">
                          <md-button v-on:click="hide" class="md-button md-theme-default">いいえ</md-button>
                          <md-button v-on:click="sendMessage()" class="md-button md-success md-theme-default">はい</md-button>
                        </div>
                      </modal>
                      <modal class="modal-mask" name="modal-success" draggable="true" :adaptive="true" :resizable="false"
                        :maxWidth="400" width="98%" height="150" styles="padding=15px;">
                        <h4 class="modal mgt-1em">送信が完了しました</h4>
                        <md-button v-on:click="hide" class="md-button md-success md-theme-default mgt-1em">OK</md-button>
                      </modal>
                      <modal class="modal-mask" name="modal-error" draggable="true" :adaptive="true" :resizable="false"
                        :maxWidth="400" width="98%" height="150" styles="padding=15px;">
                        <h4 class="modal mgt-1em" style="white-space:pre-wrap; word-wrap:break-word;">{{error_message}}</h4>
                        <md-button v-on:click="hide" class="md-button md-success md-theme-default mgt-1em">OK</md-button>
                      </modal>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="section section-contacts">
              <div class="container outer">
                <div class="flex-container">
                  <div v-for="(w,key) in work_histories" :key="key" class="inner">
                    <md-card style="box-shadow:none;">
                        <img
                          class ="img-work img-raised"
                          :src=checkImage(w.image)
                          style="object-fit: cover;"
                          :alt=imageTitle(w.image)
                        >
                        <!-- :src=w.image src="https://trace.smartag.jp/img/work_histories/0011_2_2021-07-02%2011:54:00.jpg" -->
                      <div class="md-layout">
                        <div class="md-layout-item md-layout md-alignment-center-space-around">
                          <div class="md-layout-item md-size-45" style="padding-left: 10%; padding-right: 0px;">
                            <h3 class="h5-size" style="text-align: left;">
                              <div class="heading-common heading-color-work"> 
                                {{ w.work_name }}
                              </div>
                            </h3>
                          </div>
                          <div class="md-layout-item md-size-55" style="padding-left: 5%;">
                            <h3 class="h5-size" style="text-align: left;">
                              {{ w.work_datetime }}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </md-card>
                  </div>
                </div>
              </div>
            </div>
            <div class="Page-Btn img-raised" @click="scrollTop">
              <i class="fas fa-chevron-up Page-Btn-Icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

  .heading-common{
    display:inline-block;
    padding: 5px 10px;
    border: 1px solid #333333;
    border-radius: 5px;
  }

  .heading-color-work { 
    background-color: #c8e6c9;
    border-color: #81c784;
  }

  .heading-color-producer { 
    background-color: #b2dfdb;
    border-color: #4db6ac;
    
  }

  .outer { display: table; }

  .inner { 
    display: inline;
    width: 45%; }

  .timeline-flex{
    display:flex;
    justify-content: space-around !important;
  }

  .Page-Btn{
  position: fixed;
  right: 1vw;
  bottom: 2vw;
  width: 35px;
  height: 35px;
  line-height: 32px;
  text-align: center;
  border-radius: 50%;
  background-color: #90a4ae;
  cursor: pointer;
}
</style>

<script>
  /* eslint-disable no-console */
  import axios from "axios"

  export default {
    data() {
      return {
        country: "",
        message: "",
        producer: [],
        work_histories : [],
        status_code: "",
        loading: true,
        no_image: "img/noImage.jpg",
        error_message:"",
        fb_url:"",
        items: [],
      }
    },


    bodyClass: "landing-page",

    created(){
      var vm = this
      axios.get('https://387pgsl3ej.execute-api.ap-northeast-1.amazonaws.com/dev/'
                +vm.$route.params.id,)
        .then(response => {
          vm.work_histories = response.data.work_histories,
          vm.producer = response.data.producers,
          vm.status_code  = response.status,
          vm.loading = false
        })
        .catch(error =>{
          vm.status_code  = error.response.status,
          vm.error_message = error.response.data.error_message,
          vm.loading = false
        })
    },

    computed: {
      imageTitle(image){
        return function(image){
          if(image=="")
            return "No Image";
          else
            return "Work Image";
        }
      }
    },

    methods: {
      shipmentData:function(num){
        for(var i in this.work_histories) {
          var work_histories = this.work_histories[i];
          if(work_histories.work_name === "出荷") {
            if(num === 0){
              var shipment_image = work_histories.image;
              return shipment_image;
            }else if(num === 1){
              var shipment_datetime = work_histories.work_datetime;
              return shipment_datetime;
            }else if(num === 2)
              return true;
          }
        }
        if(num === 2)
          return false;
        else
          return "";
      },

      checkImage:function(path){
        if(path == "")
          return this.no_image;
        else
          return path;
      },

      scrollTop: function(){
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },

      confirmMessage:function(){
        var vm = this;
        if(vm.country.length !=0 && vm.message.length != 0)
          vm.$modal.show('modal-confirm');
      },
    
      sendMessage:function(){
        this.$modal.hide("modal-confirm");
        var vm = this;
        var formParams = new URLSearchParams();
        vm.changeDisabled(true);
        formParams.append('country', vm.country);
        formParams.append('message', vm.message);
        var config = {
            headers: {
              'x-from' : location.origin
            }
          };
        axios.post('https://387pgsl3ej.execute-api.ap-northeast-1.amazonaws.com/dev/feedbacks/create/'
                    + vm.$route.params.id, formParams, config)
          .then(()=>{
            vm.country = '',
            vm.message = '',
            vm.$modal.show('modal-success'),
            vm.changeDisabled(false)
          })
          .catch(error=>{
            try{
                vm.error_message = error.response.data.error_message;
              }catch{
                vm.error_message = `エラーが発生しました\n時間を置いてもう一度お試しください`;
              }finally{
                vm.$modal.show('modal-error');
                vm.changeDisabled(false);
              }
          })
      },

      changeDisabled: function(flag){
        document.querySelectorAll("div#feedback input").forEach( e => e.disabled = flag );
        document.querySelectorAll("div#feedback button").forEach( e => e.disabled = flag );
        document.querySelectorAll("div#feedback textarea").forEach( e => e.disabled = flag );
        
      },

      hide() {
        this.$modal.hide("modal-confirm");
        this.$modal.hide("modal-success");
        this.$modal.hide("modal-error");
      }
    },
  };
</script>